<template>
  <div class="sub-text-container">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'SubTextContainer',
};
</script>
<style scoped lang="scss">
.sub-text-container {
  display: flex;
  flex-direction: column;
  margin: 20px auto 20px;
  max-width: 800px;
  padding: 0 20px;
  @media print, screen and (max-width: 420px) {
    padding: 0;
  }
}
</style>
